/* global api */
import modal from './modal'
import toastr from 'toastr';
(function () {
    let ventana = modal();

    let abrirLoginAlta = () => {
        let pmts = {
            v: new Date().getTime()
        };
        NProgress.start();

        axios.get(api.alta, {params: pmts})
            .then(function (response) {
                ventana.open({content: response.data})
                iniciarFormularios();
            })
            .catch(function (error) {
                console.log("-> error", error);
            })
            .finally(function () {
                NProgress.done();
            });
    };

    let $cmd = document.querySelector('meta[name="cmd"]');
    let $btnLoginAlta = document.querySelector(".usuario-btn-menu");
    if ($cmd) {
        let cmd = $cmd.getAttribute('content');
        if (cmd === "login") {
            abrirLoginAlta();
        } else if(cmd === "login-ok") {
            toastr.success('Sesión iniciada');
        }
    }

    if($btnLoginAlta) {
        $btnLoginAlta.addEventListener("click", abrirLoginAlta);
        $btnLoginAlta.addEventListener("solicitud-login", abrirLoginAlta);
    }


    let iniciarFormularios = () => {

        let $altaLogin = document.querySelectorAll(".modal form.alta, .modal form.login")

        $altaLogin.forEach(function (el) {
            el.addEventListener("submit", (e) => {
                e.preventDefault();

                const formData = new FormData(e.target)
                const url = e.target.getAttribute("action")+"?v="+(new Date().getTime());


                NProgress.start();
                axios.post(url, formData)
                    .then(function (response) {
                        ventana.open({content: response.data});
                        let ok = document.querySelector(".modal [data-ok]");

                        if(ok) {
                            let reqCheckout = localStorage.getItem("requerir-checkout");
                            if (reqCheckout === "si") {
                                localStorage.removeItem("requerir-checkout");
                                window.location.replace("/checkout/datos");
                            } else {
                                window.location.reload(false);
                            }
                        } else {
                            iniciarFormularios();
                        }
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        })


        let $btnRecuperar = document.querySelector(".btn-recuperar");

        if ($btnRecuperar) {
            $btnRecuperar.addEventListener("click", (e) => {
                e.preventDefault();
                const url = e.target.getAttribute("href")+"?v="+(new Date().getTime());
                NProgress.start();
                axios.get(url)
                    .then(function (response) {
                        ventana.open({content: response.data});
                        iniciarFormularios();
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        }

        let $formRecuperarar = document.querySelector(".modal form.recuperar");

        if ($formRecuperarar) {
            $formRecuperarar.addEventListener("submit", (e) => {
                e.preventDefault();

                const formData = new FormData(e.target)
                const url = e.target.getAttribute("action")+"?v="+(new Date().getTime());


                NProgress.start();
                axios.post(url, formData)
                    .then(function (response) {
                        ventana.open({content: response.data});
                        iniciarFormularios();
                    })
                    .catch(function (error) {
                        console.log("-> error", error);
                    })
                    .finally(function () {
                        NProgress.done();
                    });
            });
        }

    }
})();
